<template>
  <div class="container">
    <h2>{{ $t('titre.ListOfDetailMovement') }}</h2>
    <div class="card">
      <table class="table table-striped text-center">
        <thead>
          <tr>
            <th></th>
            <th>
              <input type="text" v-model="filters.serialNumber" placeholder="Filter by Serial Number"
                class="filter-input" />
            </th>
            <!--th>
              <input type="text" v-model="filters.remarque" placeholder="Filter by Remark" class="filter-input" />
            </th-->
            <th>
              <input type="text" v-model="filters.source" placeholder="Filter by Source" class="filter-input" />
            </th>
            <th>
              <input type="text" v-model="filters.movementDate" placeholder="Filter by Movement Date"
                class="filter-input" />
            </th>
            <th>
              <input type="text" v-model="filters.valueOfPeriod" placeholder="Filter by Days Difference"
                class="filter-input" />
            </th>
          </tr>
          <tr>
            <th>Details</th>
            <th @click="sortBy('serialNumber')">Serial Number <span v-html="getSortIcon('serialNumber')"></span></th>
            <!--th @click="sortBy('remarque')">Remark <span v-html="getSortIcon('remarque')"></span></th-->
            <th @click="sortBy('source')">Source <span v-html="getSortIcon('source')"></span></th>
            <th @click="sortBy('movementDate')">Movement Date <span v-html="getSortIcon('movementDate')"></span></th>
            <th @click="sortBy('valueOfPeriod')">Period <span v-html="getSortIcon('valueOfPeriod')"></span></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(detail, index) in paginatedDetails" :key="index">

            <td class="col-md-2">
              <button @click="openDetail(detail)" class="btn btn-outline-success btn-sm me-2">
                <i class="bi bi-eye"></i>
              </button>
            </td>

            <td>{{ detail.serialNumber }}</td>
            <!--td>{{ detail.remarque }}</td-->
            <td>{{ detail.source }}</td>
            <td>{{ detail.movementDate }}</td>
            <td>{{ formatPeriod(detail.valueOfPeriod, detail.typeOfPeriod) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination Controls -->
    <div class="pagination">
      <button @click="goToFirstPage" :disabled="currentPage === 1">« First</button>
      <button @click="prevPage" :disabled="currentPage === 1">❮</button>
      <span>{{ currentPage }} / {{ totalPages }}</span>
      <button @click="nextPage" :disabled="currentPage === totalPages">❯</button>
      <button @click="goToLastPage" :disabled="currentPage === totalPages">Last »</button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { DetailMovementsService } from "../api";

export default {
  data() {
    return {
      detailMovements: [],
      filters: {
        serialNumber: "",
        remarque: "",
        source: "",
        movementDate: "",
        valueOfPeriod: ""
      },
      currentPage: 1,
      pageSize: 10,
      sortKey: "", // Column name to sort
      sortOrder: 1  // 1 for ascending, -1 for descending
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.sortedDetails.length / this.pageSize);
    },
    paginatedDetails() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.sortedDetails.slice(start, end);
    },
    filteredDetails() {
      return this.detailMovements.filter((detail) => {
        return (
          detail.serialNumber.toLowerCase().includes(this.filters.serialNumber.toLowerCase()) &&
          detail.remarque.toLowerCase().includes(this.filters.remarque.toLowerCase()) &&
          detail.source.toLowerCase().includes(this.filters.source.toLowerCase()) &&
          detail.movementDate.toLowerCase().includes(this.filters.movementDate.toLowerCase()) &&
          detail.valueOfPeriod.toString().includes(this.filters.valueOfPeriod)
        );
      });
    },
    sortedDetails() {
      return [...this.filteredDetails].sort((a, b) => {
        if (!this.sortKey) return 0; // If no sorting key is selected, return original order

        let valueA = a[this.sortKey];
        let valueB = b[this.sortKey];

        // Convert movementDate to Date object for proper sorting
        if (this.sortKey === "movementDate") {
          valueA = new Date(valueA);
          valueB = new Date(valueB);
        }

        // Convert valueOfPeriod to a number
        if (this.sortKey === "valueOfPeriod") {
          valueA = parseFloat(valueA);
          valueB = parseFloat(valueB);
        }

        return (valueA > valueB ? 1 : -1) * this.sortOrder;
      });
    }
  },
  methods: {
    async fetchDetailMovements() {
      try {
        const response = await DetailMovementsService.getAllDetails();
        this.detailMovements = response;
      } catch (error) {
        console.error("Error fetching detail movements:", error);
      }
    },
    formatPeriod(value, type) {
      if (type === "D") return `${value} ${value == 1 ? "Day" : "Days"}`;
      if (type === "M") return `${value} ${value == 1 ? "Month" : "Months"}`;
      if (type === "Y") return `${value} ${value == 1 ? "Year" : "Years"}`;
      return value;
    },
    sortBy(key) {
      if (this.sortKey === key) {
        this.sortOrder *= -1; // Toggle sorting order
      } else {
        this.sortKey = key;
        this.sortOrder = 1; // Default to ascending order
      }
    },
    getSortIcon(key) {
      if (this.sortKey !== key) return "&#9650;&#9660;"; // Show up and down arrows when not sorted
      return this.sortOrder === 1 ? "&#9650;" : "&#9660;"; // Show up or down arrow based on sorting order
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    goToFirstPage() {
      this.currentPage = 1;
    },
    goToLastPage() {
      this.currentPage = this.totalPages;
    },
    openDetail(detail) {
      console.log('openDetail ' + JSON.stringify(detail))
      this.setDetailMovement(detail)
      this.$router.push({
        path: "/livestock-record" // state: { detailMovement: detail }
      });
    },
    ...mapMutations(['setDetailMovement'])
  },
  mounted() {
    this.fetchDetailMovements();
  }
};
</script>

<style scoped>
.container {
  margin-top: 20px;
  border: 1px solid #ddd;
  padding: 0px;
  border-radius: 10px;
}

h2 {
  background-color: #47c399;
  border-radius: 10px 10px 0 0;
  color: azure;
  padding: 3px;
  text-align: justify;
  padding-left: 15px;
}

/* Table Styles */
.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.table thead tr {
  background-color: #f2f2f2;
  cursor: pointer;
}

.table th,
.table td {
  border: 1px solid #ddd;
  padding: 6px;
  text-align: center;
}

.table th span {
  margin-left: 5px;
  font-size: 12px;
  color: #007bff;
}

/* Filter Styles */
.filter-input {
  width: 100%;
  padding: 6px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  box-sizing: border-box;
}

/* Pagination Styles */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}

.pagination button {
  background-color: #007bff;
  color: white;
  border: none;
  padding: 5px 10px;
  margin: 0 5px;
  border-radius: 5px;
  cursor: pointer;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.pagination span {
  font-size: 16px;
  font-weight: bold;
}
</style>
